import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { SxProps } from '@mui/system';
import { JSXElementConstructor, ReactElement, SyntheticEvent } from 'react';

type CheckboxProps = {
  label: string | number | ReactElement<any, string | JSXElementConstructor<any>>;
  name: string;
  sx?: SxProps;
  onChange?: (event: SyntheticEvent<Element, Event>, checked: boolean) => void;
  checked?: boolean;
};

export const Checkbox = ({ label, name, sx, onChange, checked }: CheckboxProps) => (
  <FormControlLabel
    name={name}
    label={label}
    onChange={onChange}
    control={<MuiCheckbox data-testid={name} role="checkbox" name={name} checked={checked} />}
    sx={{ ...sx }}
  />
);
